export default __webpack_public_path__ + "static/media/logo-with-name-white.c47a9ad0.png";